import { createSelector } from "reselect";
import getElementStatusFilter from "./get_element_status_filter";

const getInPlaceElementsShown = createSelector([
  getElementStatusFilter
], (filter) => filter.inPlaceElementsShown);

export default getInPlaceElementsShown;
